module.exports = __webpack_public_path__ + "img/16581311_L.45f824cf.png";